import {
  IonCol,
  IonGrid,
  IonRow,
  IonSearchbar,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { utilService } from "../../../../../../../../services";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import "./SwapTransferSearch.scss";
import classNames from "classnames";
import Loader from "../../../../../../../../components/Shared/Loader/Loader";
import { IonInfiniteScroll } from "@ionic/react";

interface ContainerProps {
  unitDetails: any;
  changeType: any;
  type: any;
  sendSelectedCardId: (data: any) => void;
  patientData: any;
  unitId?: any;
}

const SwapTransferSearch: React.FC<ContainerProps> = (props) => {
  const siteId = props.unitDetails.unitDetails[0].site?.siteId;
  const [searchText, setSearchText] = useState<string>("");
  const [unitPageNumber, setUnitPageNumber] = useState<number>(1);
  const [bedPageNumber, setBedPageNumber] = useState<number>(1);
  const [unitResponseData, setUnitResponseData] = useState([]);
  const [arrayList, setArrayList] = useState<any>([]);
  const [unitId, setUnitId] = useState(
    props.unitDetails.unitDetails[0].unit?.unitId
  );
  const [bedId, setBedId] = useState();
  const [bedResponseData, setBedResponseData] = useState([]);
  const [isLoaderActive, setLoaderStatus] = useState(false);
  const [disableInfiniteScroll, setDisableInfiniteScroll] =
    useState<boolean>(false);

  useEffect(() => {
    if (props.type === "unit") {
      getUnitLists();
    } else {
      getBedList();
    }
  }, []);
  useEffect(() => {
    if (
      props.unitId !== "" &&
      props.unitId !== undefined &&
      props.type === "bed"
    ) {
      setUnitId(props.unitId);
      getBedList(props.unitId);
    }
  }, [props.unitId]);

  const getUnitLists = async () => {
    const params = {
      page: unitPageNumber,
      siteId: siteId,
      reg_code: utilService.getNetwork(),
    };
    setLoaderStatus(true);
    const respResult: any = await statusBoardService.getAllUnitList(params);
    if (respResult.isSuccess && respResult.unitList.length) {
      if (unitPageNumber === 1) {
        setDisableInfiniteScroll(false);
      }
      if (!respResult.unitList[0].next) {
        setDisableInfiniteScroll(true);
      }
      setLoaderStatus(false);
      setUnitResponseData(respResult.unitList[0]);
      setUnitDataList(respResult.unitList[0].data);
    } else {
      setLoaderStatus(false);
    }
  };

  const getBedList = async (selectedUnitId?: any) => {
    props.sendSelectedCardId(undefined);
    const params = {
      page: bedPageNumber,
      unitId: selectedUnitId ? selectedUnitId : unitId,
      type: props.changeType.id,
      reg_code: utilService.getNetwork(),
    };
    setLoaderStatus(true);
    const respResult: any = await statusBoardService.getAllBedList(params);
    if (respResult.isSuccess && respResult.bedList.length) {
      setLoaderStatus(false);
      setBedResponseData(respResult.bedList[0]);
      setBedDataList(respResult.bedList[0].data);
    } else {
      setLoaderStatus(false);
    }
  };

  const setUnitDataList = (resultData: any) => {
    const unitList: any = [];
    resultData.forEach((unitData: any) => {
      unitList.push(setUnitDataModel(unitData));
    });
    setArrayList(unitList);
  };

  const setBedDataList = (resultData: any) => {
    const bedList: any = [];
    resultData.forEach((bedData: any) => {
      if (
        props.patientData &&
        props.patientData.id &&
        bedData.id !== props.patientData.id
      ) {
        bedList.push(setBedDataModel(bedData));
      }
    });
    setArrayList(bedList);
  };

  const setUnitDataModel = (unit: any) => {
    const dataModel = {
      id: unit.unitId,
      name: unit.unitName,
    };

    return dataModel;
  };

  const setBedDataModel = (bedData: any) => {
    const dataModel = {
      id: bedData.id,
      name: bedData.name,
    };

    return dataModel;
  };

  const handleSearch = (event: any) => {
    setSearchText(event.detail.value!);
    if (props.type === "unit" && searchText !== event.detail.value!) {
      handleUnitSearch(event.detail.value!);
    } else if (props.type === "bed" && searchText !== event.detail.value!) {
      handleBedSearch(event.detail.value!);
    }
  };

  const handleUnitSearch = (searchText: string) => {
    if (searchText !== "") {
      searchUnit(searchText);
    } else {
      getUnitLists();
    }
  };

  const handleBedSearch = (searchText: string) => {
    if (searchText !== "") {
      searchBed(searchText);
    } else {
      getBedList();
    }
  };

  const searchUnit = async (searchText: string) => {
    const params = {
      page: unitPageNumber,
      siteId: siteId,
      reg_code: utilService.getNetwork(),
      name: searchText,
    };
    const respResult: any = await statusBoardService.searchUnit(params);
    if (respResult.isSuccess && respResult.unitList.length) {
      setUnitResponseData(respResult.unitList[0]);
      setUnitDataList(respResult.unitList[0].data);
    } else {
    }
  };

  const searchBed = async (searchText: string) => {
    const params = {
      page: bedPageNumber,
      unitId: unitId,
      type: props.changeType.id,
      reg_code: utilService.getNetwork(),
      name: searchText,
    };
    const respResult: any = await statusBoardService.searchBed(params);
    if (respResult.isSuccess && respResult.bedList.length) {
      setBedResponseData(respResult.bedList[0]);
      setBedDataList(respResult.bedList[0].data);
    } else {
    }
  };

  const selectCard = (selecedId: any) => {
    props.sendSelectedCardId(selecedId);
    if (props.type === "unit") {
      setUnitId(selecedId);
    } else {
      setBedId(selecedId);
    }
  };
  const getNextList = async ($event: CustomEvent<void>) => {
    if (props.type === "unit") {
      await getUnitLists();
    } else if (props.type === "bed") {
      await getBedList();
    }
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  };

const { t } = useTranslation("statusBoard");

  return (
    <div className="swap-transfer-search-cont">
      <IonGrid className="swap-transfer-search-grid">
        <IonRow>
          <IonCol>
            <div className="search-type">
           {t("select")}{" "}
{props.type === "unit" ? t("unit") : t("bed")}
            </div>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol className="search-cont">
            <IonSearchbar
              className="search-input"
              debounce={1000}
              value={searchText}
              onIonChange={(e: any) => handleSearch(e)}
            placeholder={t("search")}
              type="search"
              clearIcon="never"
            ></IonSearchbar>
          </IonCol>
        </IonRow>
        <IonRow className="list-container">
          <IonCol className="scroll-content">
            {isLoaderActive && (
              <div>
                <div className="loader-container">
                  <Loader></Loader>
                </div>
              </div>
            )}
            {!isLoaderActive && (
              <div
                className={classNames({
                  "card-row": true,
                })}
              >
                {arrayList && !isLoaderActive && arrayList.length ? (
                  arrayList.map((item: any, index: any) => {
                    return (
                      <div
                        className={classNames({
                          "unit-card": props.type === "unit" ? true : false,
                          "bed-card": props.type === "bed" ? true : false,
                          "selected-card":
                            (props.type === "unit" && unitId === item?.id) ||
                            (props.type === "bed" && bedId === item?.id)
                              ? true
                              : false,
                          "item-card": true,
                        })}
                        key={index}
                        onClick={() => selectCard(item.id)}
                      >
                        <span
                          className={classNames({
                            "icon-add":
                              (props.type === "unit" && unitId === item?.id) ||
                              (props.type === "bed" && bedId === item?.id)
                                ? true
                                : false,
                          })}
                        ></span>
                        {item.name}
                      </div>
                    );
                  })
                ) : (
                  <div className="no-results-label">{t('noResults')}</div>
                )}
              </div>
            )}
          </IonCol>
        </IonRow>
        <IonInfiniteScroll
          threshold="20%"
          disabled={disableInfiniteScroll}
          onIonInfinite={(e: CustomEvent<void>) => getNextList(e)}
        >
          {/* <IonInfiniteScrollContent></IonInfiniteScrollContent> */}
        </IonInfiniteScroll>
      </IonGrid>
    </div>
  );
};

export default SwapTransferSearch;
